import { keptFromEarlierLine, type StatusForAnnotation } from '../../lib/copy';

/**
 * The one line under an analysis section's sub-head when the subject's current
 * status does not derive that kind (design note §2.5) — a prospect-era Fit on a
 * member's dossier, say.
 *
 * The section, its head and its content are untouched: a switch changes nothing
 * already on record (§1.4), so nothing here hides or greys a reading. All this
 * says is that the next run will not write it again.
 *
 * One component rather than a line composed at each section, so the wording and
 * where it sits cannot drift apart between Fit, Conversation notes and
 * Relationship. `lib/copy.ts` owns which kinds get a line at all.
 */
export function KeptFromEarlier({
  subject,
  kind,
}: {
  subject: StatusForAnnotation | undefined;
  kind: string;
}) {
  const line = keptFromEarlierLine(subject, kind);
  return line ? <div className="src kept-from-earlier">{line}</div> : null;
}
